import React, { useState } from 'react'
import { Navbar, Nav, Container, Button } from 'react-bootstrap'
import { useNavigate, useLocation } from 'react-router-dom'

const Header = ({activeState, heading}) => {
  const location = useLocation();
    const navigate = useNavigate();
    const [active, setActive] = useState('/');
    const checkPath = (path) => {
      // if(path === location.pathname){
        if(path === active){
        // return 'active'
        return 'fw-bold active'
      }else{
        return ''
      } 
    }
  return (
    <>   
    <Navbar sticky='top' expand="lg"  data-bs-theme="light" collapseOnSelect
    className='topBar py-2'
    style={{ 
      position: 'fixed',
      height: '60px',
      width: '100%'
      // backgroundColor: '#9A9BB4',
      // backgroundColor: 'aliceblue'
     }}
    >
      {/* <Container> */}
        <Navbar.Brand className='ms-1 py-0 d-flex align-items-center' href="#"
        
        >
            <img src='/bsc_logo2.png'
          style={{ 
            borderTopLeftRadius: '25%',
            borderTopRightRadius: '25%',
            // borderBottomLeftRadius: '5%',
            // borderBottomRightRadius: '5%',
            // borderRadius: '50%',
            width:'14rem',
            height: '50px',
            // borderRadius: '10%'
           }}
          />
          
        </Navbar.Brand>
        <Navbar.Toggle className='me-3' variant='outline-light' aria-controls="basic-navbar-nav" 
        style={{ backgroundColor: 'white' }}
        />
        <Navbar.Collapse id="basic-navbar-nav"
        className='mx-3'
        style={{ 
          backgroundColor: 'inherit'
         }}
        >
          <Nav className="header-link-body ms-auto d-flex justify-content-end my-0">
            <Nav.Link 
            
            onClick={() => {
                  window.scrollTo({
                    top: 0
                  })
                  setActive('/');
            }}
            href="#">
              <a 
              style={{ 
                // border: 0,
                // borderColor: 'white',
                fontSize:'13px'
                // borderStyle: 'dashed'
               }}
               className={'header-btn btn form-control text-start ' + checkPath('/')}>
                Home
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              const el = document.getElementById('events');
              el.scrollIntoView({behavior: 'smooth', offsetTop: 50});
                  setActive('/events');
            }}
            href="#">
              <a 
              style={{ 
                // border: 0,
                // borderColor: 'white',
                fontSize:'13px'
                // borderStyle: 'dashed'
               }}
               className={'header-btn btn form-control text-start ' + checkPath('/events')}>
                Events
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              const el = document.getElementById('units');
                el.scrollIntoView({behavior: 'smooth', offsetTop: 0});
                setActive('/units')
            }}
            href="#">
              <a 
              style={{ 
                // border: 0,
                // borderColor: 'white',
                // borderStyle: 'dashed'
                fontSize:'13px'
               }}
               className={'header-btn btn form-control text-start ' + checkPath('/units')}>
                Units
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              const el = document.getElementById('members');
                el.scrollIntoView({behavior: 'smooth', offsetTop: 0});
                setActive('/members')
            }}
            href="#">
              <a 
              style={{ 
                // border: 0,
                // borderColor: 'white',
                // borderStyle: 'dashed'
                fontSize:'13px'
               }}
               className={'header-btn btn form-control text-start ' + checkPath('/members')}>
                Members
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              const el = document.getElementById('gallery');
                el.scrollIntoView({behavior: 'smooth', });
                // el.scrollTo({top: 0})
                console.log(el.getBoundingClientRect());
                setActive('/gallery')
            }}
            href="#">
              <a 
              id='gallery-btn'
              style={{ 
                fontSize:'13px'
               }}
               className={'header-btn btn form-control text-start ' + checkPath('/gallery')}>
                Gallery
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              const el = document.getElementById('contact');
                el.scrollIntoView({behavior: 'smooth', });
                // el.scrollTo({top: 0})
                console.log(el.getBoundingClientRect());
                setActive('/contact')
            }}
            href="#">
              <a 
              id='contact-btn'
              style={{ 
                fontSize:'13px'
               }}
               className={'header-btn btn form-control text-start ' + checkPath('/contact')}>
                Contact
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              const el = document.getElementById('about');
                el.scrollIntoView({behavior: 'smooth', });
                // el.scrollTo({top: 0})
                console.log(el.getBoundingClientRect());
                setActive('/about')
            }}
            href="#">
              <a 
              id='about-btn'
              style={{ 
                fontSize:'13px'
               }}
               className={'header-btn btn form-control text-start ' + checkPath('/about')}>
                About
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              navigate('/register')
            }}
            href="#">
              <a 
              id='contact-btn'
              style={{ 
                fontSize:'13px'
               }}
               className={'header-btn btn form-control text-start '}>
                Register
              </a>
            </Nav.Link>
            <Nav.Link 
            
            onClick={() => {
              navigate('/login')
            }}
            href="#">
              <a 
              id='contact-btn'
              style={{ 
                fontSize:'13px'
               }}
               className={'header-btn btn form-control text-start '}>
                Login
              </a>
            </Nav.Link>
            
          </Nav>
        </Navbar.Collapse>
      {/* </Container> */}
    </Navbar>
    {/* {
      heading && 
      <div className=' text-white d-flex align-items-center header-container'
      >
      <h1 className='ms-4 header'>{heading} </h1>
      </div>
    } */}
    </>
  )
}

export default Header
